import { Component } from 'react';
import { Result, Button } from 'antd';

// 全局错误边界：任一页面渲染异常时兜底展示，避免整页白屏
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('页面渲染异常:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="页面出错了"
          subTitle="页面渲染出现异常，请尝试刷新页面"
          extra={<Button type="primary" onClick={this.handleReload}>刷新页面</Button>}
        />
      );
    }
    return this.props.children;
  }
}
